"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Workbook = /** @class */ (function () {
    function Workbook(_workbookImpl) {
        this._workbookImpl = _workbookImpl;
    }
    Workbook.prototype.getAllDataSourcesAsync = function () {
        return this._workbookImpl.getAllDataSourcesAsync();
    };
    return Workbook;
}());
exports.Workbook = Workbook;
//# sourceMappingURL=Workbook.js.map